import { createUseStyles } from 'react-jss';
import { mixins } from '@/styles/mixins';
import { DESKTOP_FONT_SIZES, DESKTOP_SIZES_BREAKPOINT, MOBILE_FONT_SIZES, } from '@/styles/themes/components';
export const useInsuranceStyles = createUseStyles((theme) => ({
    root: {
        background: theme.colors.cloud,
        borderRadius: '12px',
        marginBottom: '8px',
        boxShadow: theme.elevations.cloud,
        padding: '12px',
        [theme.breakpoints.up(DESKTOP_SIZES_BREAKPOINT)]: {
            padding: '15px',
            '&[data-insurer="true"]': {
                '& #input-error': {
                    '&[data-error="true"]': {
                        [theme.breakpoints.up('lg')]: {
                            marginBottom: -6,
                        },
                    },
                },
            },
        },
    },
    header: {
        marginBottom: '20px',
    },
    title: {
        fontSize: MOBILE_FONT_SIZES.title,
        color: theme.colors.sky,
        [theme.breakpoints.up(DESKTOP_SIZES_BREAKPOINT)]: {
            fontSize: DESKTOP_FONT_SIZES.title,
        },
    },
    subtitle: {
        fontWeight: 400,
        color: theme.colors.textPrimary,
        display: 'inline-block',
        fontSize: MOBILE_FONT_SIZES.small,
        [theme.breakpoints.up(DESKTOP_SIZES_BREAKPOINT)]: {
            fontSize: DESKTOP_FONT_SIZES.small,
        },
    },
    deleteIcon: {
        margin: '0px 0px 2px 2px',
        width: 20,
        height: 20,
        borderRadius: 999,
        outlineOffset: 2,
        '& svg > path': {
            fill: `${theme.colors.error} !important`,
        },
    },
    buttons: {
        marginTop: '12px',
        display: 'flex',
        gap: '6px',
        justifyContent: 'space-between',
        flexDirection: 'column-reverse',
        [theme.breakpoints.up('lg')]: {
            flexDirection: 'row',
        },
    },
    termsAndAgreement: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        fontWeight: 400,
        color: theme.colors.textPrimary,
        marginTop: '8px',
        whiteSpace: 'pre-wrap',
        textAlign: 'center',
        fontSize: MOBILE_FONT_SIZES.main,
        '& a': {
            ...mixins.brandLinkColor(theme),
        },
        [theme.breakpoints.up(DESKTOP_SIZES_BREAKPOINT)]: {
            fontSize: DESKTOP_FONT_SIZES.main,
        },
    },
}), { name: 'insurance' });
